import React from 'react';
import { useLocation } from 'react-router-dom';

import { Col, Container, Row } from 'reactstrap';

import { If } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import errorImage from 'assets/images/error-img.png';
import { DashboardButton } from 'components/buttons/dashboard';
import { LoginButton } from 'components/buttons/login';
import { useAppSelector } from 'hooks/store';
import { selectIsAuthenticated } from 'store/selectors';
import { IErrorPage } from 'types/pages/common';

const ErrorPage: React.FC<IErrorPage> = ({ children, message }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { state } = useLocation();

  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <Container>
          <Row>
            <Col>
              <div className="mb-5 text-center">
                <h1 className="display-2 fw-medium">{children}</h1>
                <h4 className="text-uppercase">{message}</h4>
                <If condition={isDefined(state.error)}>
                  <div className="d-flex align-self-start">
                    <details>
                      <div>{state.error.toString()}</div>
                    </details>
                  </div>
                </If>
                <div className="mt-5 text-center">{isAuthenticated ? <DashboardButton /> : <LoginButton />}</div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col
              md={8}
              xl={6}>
              <div>
                <img
                  alt=""
                  className="img-fluid"
                  src={errorImage}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ErrorPage;
